<template>
  <div :id="`${match.id}-parent`" class="accordion">
    <div class="accordion-item" :class="{ 'accordion-item--real': isRealMatch }">
      <h3 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#${match.id}-details-panel`"
          aria-expanded="false"
          :aria-controls="`${match.id}-details-panel`"
        >
          <span class="outcome" :aria-label="outcomeLabel">{{ outcomeEmoji }}</span>
          <score-line-display
            :home-team="match.homeTeam"
            :away-team="match.awayTeam"
            :score="match.score"
          />
        </button>
      </h3>
      <p v-if="isRealMatch" class="real-match">
        Match réel
      </p>
      <div
        :id="`${match.id}-details-panel`"
        class="accordion-collapse collapse"
        :data-bs-parent="`#${match.id}-parent`"
      >
        <div class="accordion-body">
          <score-display :match="match" />
          <scorers-display :match="match" class="mt-3" />

          <a class="show-players" @click="showPlayers = true">
            <span>Afficher les joueurs</span>
            <info-icon />
          </a>
        </div>
      </div>
    </div>
  </div>

  <match-details-display
    :match="match"
    :show="showPlayers"
    @close="showPlayers = false"
  >
    <template #title>
      <score-line-display
        :home-team="match.homeTeam"
        :away-team="match.awayTeam"
        :score="match.score"
      />
    </template>
  </match-details-display>
</template>

<script setup>
import { computed, ref } from "vue";

import InfoIcon from "@/components/icons/InfoIcon.vue";
import MatchDetailsDisplay from "@/components/match/MatchDetailsDisplay.vue";
import ScorersDisplay from "@/components/player/ScorersDisplay.vue";
import ScoreDisplay from "@/components/score/ScoreDisplay.vue";
import ScoreLineDisplay from "@/components/score/ScoreLineDisplay.vue";
import { OUTCOME_EMOJIS, OUTCOME_LABELS, OUTCOMES } from "@/constants/outcomes";
import { Match } from "@/models/match/Match";

const props = defineProps({
  match: {
    type: Match,
    required: true,
  },
  outcome: {
    type: String,
    required: true,
    validator: (value) => Object.values(OUTCOMES).includes(value),
  },
  isRealMatch: {
    type: Boolean,
    default: false,
  },
});

const showPlayers = ref(false);

const outcomeEmoji = computed(() => OUTCOME_EMOJIS[props.outcome]);
const outcomeLabel = computed(() => OUTCOME_LABELS[props.outcome]);
</script>

<style lang="scss" scoped>
.accordion-button {
  gap: 8px;
  // Padding resserré : plus de place pour les noms sur mobile
  padding: 0.75rem 0.6rem;
}

.outcome {
  // Largeur fixe : l'émoji ne décale plus le score d'une ligne à l'autre
  flex: 0 0 1.6rem;
  width: 1.6rem;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1;
}

.real-match {
  margin: 0;
  padding: 2px 12px;
  font-size: 0.75rem;
  color: var(--bs-gray);
  text-align: left;
}

.accordion-item--real {
  border: 2px solid var(--bs-primary);

  .accordion-button {
    background-color: var(--bs-primary-bg-subtle);
  }
}

.show-players {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2vh;
  cursor: pointer;
}
</style>